import { XIcon } from "lucide-react";
import type * as React from "react";

import { cn } from "@/web/lib/styling";

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  icon?: React.ReactNode;
  className?: string;
}

export function FilterChip({ label, onRemove, icon, className }: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={onRemove}
      className={cn(
        "inline-flex h-9 shrink-0 cursor-pointer items-center gap-1.5 rounded-none border border-[rgba(7,15,34,0.1)]",
        "bg-white px-2",
        "transition-colors duration-200 hover:bg-gray-50",
        "focus-visible:ring-2 focus-visible:ring-black/20 focus-visible:outline-none",
        className,
      )}
    >
      {icon && (
        <span className="flex size-[14px] shrink-0 items-center justify-center text-[#070f22]">
          {icon}
        </span>
      )}
      <span className="truncate text-sm font-medium text-[#070f22]">{label}</span>
      <XIcon className="size-[14px] shrink-0 text-[#070f22]" aria-hidden />
    </button>
  );
}
